import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { customStorage } from './utils';
import { AppVersion, GenericState } from '@/types';
import Config from '@/config';
import { Card, CardSet } from '@ygoargentina/sdk/api/api.types';

export type CardState = GenericState & {
  cards: Card[];
  cardSets: CardSet[];

  setCards: (cards: Card[]) => void;
  setCardSets: (cardSets: CardSet[]) => void;
};

export const cardsInitialState = {
  cards: [],
  cardSets: [],
};

export const useCardStore = create<
  CardState,
  [['zustand/devtools', never], ['zustand/persist', CardState]]
>(
  devtools(
    persist(
      (set) => ({
        ...cardsInitialState,

        setCards: (cards: Card[]) => set((state) => ({ ...state, cards })),
        setCardSets: (cardSets: CardSet[]) =>
          set((state) => ({ ...state, cardSets })),
        resetStore: () => set(() => cardsInitialState),
      }),
      {
        name: `${Config.sessionKey}-cards@${AppVersion}`,
        storage: createJSONStorage<CardState>(() => customStorage),
      }
    )
  )
);
